export default {
  firstPart: {
    title: "Alcatel-Lucent Enterprise<br/>M8 DeskPhone",
    soon: "Launching Soon",
    day: "DAYS",
    hour: "HOURS",
    min: "MINUTES",
    sec: "SECONDS",
    MoreThanPhone: "More Than A Phone",
    moreInfo: "More Infomation",
  },
  secondPart: {
    tabs1: "Product Features",
    tabs2: "Applications",
    features1: {
      title: "Making business connections easier",
      desc: "Built for life and work",
      img1: "Frictionless<br />Communication",
      img2: "Seamless<br />Synchronization",
      img3: "Augmented<br />UserExperience",
      img4: "Enhanced<br />Speed &<br />Performance",
      img5: "Conference<br />Anywhere",
    },
    features2: {
      title: "Smart design Genuine luxury",
      desc: "",
      text1: "Touch-sensitive keys",
      text2: "5-inch IPS display",
    },
    features3: {
      title: "No ambiguity",
      desc: "",
      text1: "Super Wideband (SWB)",
    },
    features4: {
      title: "So immersive So flexible",
      desc: "",
      text1: "360-degree audio tuning",
    },
    features5: {
      title: "Rich connectivity Simple synchronization",
      desc: "",
      text1: "Dual-band Wi-Fi (2.4/5G)",
      text2: "Bluetooth 5.0",
    },
    features6: {
      title: "Super speed",
      desc: "",
      text1: "New architecture",
      text2: "New quad-core processor",
      text3: "12-party conferencing",
    },
    apps1: {
      title: "In the office",
      desc: "Centralize multi-media devices",
    },
    apps2: {
      title: "In a meeting room",
      desc: "Audio speaker",
    },
    apps3: {
      title: "In a huddle room",
      desc: "Conferencing phone",
    },
    apps4: {
      title: "In the hotel suite",
      desc: "Audio speaker",
    },
    apps5: {
      title: "Work from home",
      desc: "Effective Balanced",
    },
  },
  rc: {
    name: "Name*",
    country: "Country*",
    company: "Company",
    position: "Position",
    email: "Email*",
    phone: "Phone Number*",
    contact: "Contact us",
    salesContact: "Sales contact",
    technicalSupport: "Technical support",
    addr: "<p>2/F, 1 Building,No.60 Naxian Road,</p><p>Pudong New Area,Shanghai 201210,P.R.C.</p>",
    web: "www.aledevice.com",
    weixin: "ALE Device",
    register: "Register to attend the launch conference",
    submit: "Submit",
    message: "Optional: briefly describe your requirements",
    Europe: "Europe",
    NorthAmerica: "North America",
    China: "China",
    OtherAPAC: "Other Countries in APAC",
    PleaseEnter: "Please enter",
    contactInfo: "Contact Information",
  },
  footer: {
    tabs1: "Register to attend",
    tabs2: "M8 DeskPhone",
    tabs3: "Contact us",
  },
};
